export enum GatewayOrderType {
  CREATE_DEVICES = "CREATE_DEVICES"
}
